import React, {Component} from 'react';
import styles from './ThirdPartyInfo.css';
import {DeereCachedFetch} from '../../../shared/fetch';
import {Form} from '@deere/ux.uxframe-react';
import ThirdPartyStepper from '../Stepper';
import ThirdPartyInfo, {OnDemandThirdParty} from './ThirdPartyInfo';
import {Divider} from '@material-ui/core';
import AddNewSigner from './AddNewSigner';
import {FormattedMessage} from 'react-intl';
import AddNewProxy from './AddNewProxy';

export class ThirdParties extends Component {

  state = {
      quoteNumber: this.props.quoteNumber,
      alfaDealerIdentifier: this.props.alfaDealerIdentifier,
      primaryCustomer: {},
      coBorrowers: [],
      associates: [],
      guarantors: [],
      onDemand: [],
      dealer: {},
      allThirdParties: [],
      signersList: [],
      defaultTPs: []
  };

  async componentDidMount() {
      const promises = [];
      promises.push(
          DeereCachedFetch(`/api/third-parties/${this.state.quoteNumber}`, {
              cacheDuration: 'forever'
          })
      );

      promises.push(
          DeereCachedFetch(
              `/api/third-parties/dealer/${this.state.alfaDealerIdentifier}`,
              {
                  cacheDuration: 'forever'
              }
          )
      );


      const [thirdPartyDetails, dealer] = await Promise.all(promises);

      let recipientId = 1;
      const initializedThirdParties = thirdPartyDetails.map((thirdParty) => ({
          ...thirdParty,
          recipientId: recipientId++,
          signer: false,
          signingOrder: 1,
          signingMethod: 'Sign by email'
      }));
      const initializedDealer = {
          ...dealer,
          recipientId: recipientId++,
          signer: false,
          signingOrder: 1,
          signingMethod: 'Sign by email'
      };
      const allThirdParties = [...initializedThirdParties, initializedDealer];

      this.setState({
          primaryCustomer: initializedThirdParties.find((thirdParty) => thirdParty.role === 'PRIMARY') || {},
          coBorrowers: initializedThirdParties.filter((thirdParty) => thirdParty.role === 'CO_BORROWER'),
          guarantors: initializedThirdParties.filter((thirdParty) => thirdParty.role === 'GUARANTOR'),
          associates: initializedThirdParties.filter((thirdParty) => thirdParty.role === 'ASSOCIATE'),
          dealer: initializedDealer,
          allThirdParties,
          defaultTPs: allThirdParties
      });
  }

  getOnDemandSigners = (onDemandSigners) => {
      this.setState((prevState) => {
          const initializedSigner = {
              ...onDemandSigners,
              recipientId: prevState.allThirdParties.length + 1
          };
          const allThirdParties = [...prevState.allThirdParties, initializedSigner];

          return {
              onDemand: [...prevState.onDemand, initializedSigner],
              allThirdParties,
              signersList: allThirdParties.filter((thirdParty) => thirdParty.signer)
          };
      }, () => this.props.getSignerDetails(this.state.signersList));
  };

  getOrderInfo = (data) => {
      let updatedField;
      let updatedValue;
      let matchRole = false;

      if ('signer' in data) {
          updatedField = 'signer';
          updatedValue = data.signer;
          matchRole = true;
      } else if ('signingMethod' in data) {
          updatedField = 'signingMethod';
          updatedValue = data.signingMethod;
      } else if ('emailID' in data) {
          updatedField = 'emailID';
          updatedValue = data.emailID;
      } else if ('signingOrder' in data) {
          updatedField = 'signingOrder';
          updatedValue = parseInt(data.signingOrder);
      } else if ('phoneNumber' in data) {
          updatedField = 'phoneNumber';
          updatedValue = data.phoneNumber;
      } else if ('representativeFor' in data) {
          updatedField = 'representativeFor';
          updatedValue = data.representativeFor;
      }

      this.setState((prevState) => {
          const matchesParty = (thirdParty) =>
              thirdParty.tpNumber === data.tpNumber && (!matchRole || thirdParty.role === data.role);
          const updateParty = (thirdParty) =>
              (matchesParty(thirdParty) ? {...thirdParty, [updatedField]: updatedValue} : thirdParty);
          const allThirdParties = prevState.allThirdParties.map(updateParty);

          return {
              allThirdParties,
              onDemand: prevState.onDemand.map(updateParty),
              signersList: allThirdParties.filter((thirdParty) => thirdParty.signer)
          };
      }, () => this.props.getSignerDetails(this.state.signersList));
  };

  render() {
      return (
          <React.Fragment>
              <Form className={styles.thirdPartiesTab}>
                  {this.state.primaryCustomer.tpNumber ? <ThirdPartyInfo
                      countryCode={this.props.countryCode}
                      emailId={this.state.primaryCustomer.emailID}
                      enabled={this.props.signersInSelectedDocuments.has('PRIMARY')}
                      isDuplicate={Array.from(this.props.duplicateSignerSet).includes(
                          this.state.primaryCustomer.tpNumber
                      )}
                      isDuplicateEmailMobile={Array.from(this.props.duplicateEmailMobileNoSet).includes(
                          this.state.primaryCustomer.tpNumber
                      )}
                      key={'primary-' + this.state.primaryCustomer.tpNumber}
                      name={this.state.primaryCustomer.name}
                      parentCallback={this.getOrderInfo.bind(this)}
                      phoneNumber={this.state.primaryCustomer.phoneNumber}
                      role={this.state.primaryCustomer.role}
                      talf_id={this.state.primaryCustomer.tpNumber}
                  /> : ''}

                  {this.state.coBorrowers.map((coBorrower) => (
                      <ThirdPartyInfo
                          countryCode={this.props.countryCode}
                          emailId={coBorrower.emailID}
                          enabled={this.props.signersInSelectedDocuments.has('CO_BORROWER')}
                          isDuplicate={Array.from(this.props.duplicateSignerSet).includes(
                              coBorrower.tpNumber
                          )}
                          isDuplicateEmailMobile={Array.from(this.props.duplicateEmailMobileNoSet).includes(
                              coBorrower.tpNumber
                          )}
                          key={coBorrower.tpNumber}
                          name={coBorrower.name}
                          parentCallback={this.getOrderInfo.bind(this)}
                          phoneNumber={coBorrower.phoneNumber}
                          role={coBorrower.role}
                          talf_id={coBorrower.tpNumber}
                      />
                  ))}

                  {this.state.associates.map((associate) => (
                      <ThirdPartyInfo
                          countryCode={this.props.countryCode}
                          emailId={associate.emailID}
                          enabled={this.props.signersInSelectedDocuments.has('ASSOCIATE')}
                          isDuplicate={Array.from(this.props.duplicateSignerSet).includes(
                              associate.tpNumber
                          )}
                          isDuplicateEmailMobile={Array.from(this.props.duplicateEmailMobileNoSet).includes(
                              associate.tpNumber
                          )}
                          key={associate.tpNumber}
                          name={associate.name}
                          parentCallback={this.getOrderInfo.bind(this)}
                          phoneNumber={associate.phoneNumber}
                          role={associate.role}
                          talf_id={associate.tpNumber}
                      />
                  ))}

                  {this.state.guarantors.map((guarantor) => (
                      <ThirdPartyInfo
                          countryCode={this.props.countryCode}
                          emailId={guarantor.emailID}
                          enabled={this.props.signersInSelectedDocuments.has('GUARANTOR')}
                          isDuplicate={Array.from(this.props.duplicateSignerSet).includes(
                              guarantor.tpNumber
                          )}
                          isDuplicateEmailMobile={Array.from(this.props.duplicateEmailMobileNoSet).includes(
                              guarantor.tpNumber
                          )}
                          key={guarantor.tpNumber}
                          name={guarantor.name}
                          parentCallback={this.getOrderInfo.bind(this)}
                          phoneNumber={guarantor.phoneNumber}
                          role={guarantor.role}
                          talf_id={guarantor.tpNumber}
                      />
                  ))}

                  <ThirdPartyInfo
                      countryCode={this.props.countryCode}
                      emailId={this.state.dealer.emailID}
                      enabled={this.props.signersInSelectedDocuments.has('DEALER')}
                      isDuplicate={Array.from(this.props.duplicateSignerSet).includes(
                          this.state.dealer.tpNumber
                      )}
                      isDuplicateEmailMobile={Array.from(this.props.duplicateEmailMobileNoSet).includes(
                          this.state.dealer.tpNumber
                      )}
                      key={'dealer' + this.state.dealer.tpNumber}
                      name={this.state.dealer.name}
                      parentCallback={this.getOrderInfo.bind(this)}
                      phoneNumber={this.state.dealer.phoneNumber}
                      role={this.state.dealer.role}
                      talf_id={this.state.dealer.tpNumber}
                  />

                  {this.state.onDemand.map((ondemand) => (
                      <OnDemandThirdParty
                          allThirdParties={this.state.allThirdParties}
                          defaultTPs={this.state.defaultTPs}
                          emailId={ondemand.emailID}
                          isDuplicate={Array.from(this.props.duplicateSignerSet).includes(
                              ondemand.tpNumber
                          )}
                          isDuplicateEmailMobile={Array.from(this.props.duplicateEmailMobileNoSet).includes(
                              ondemand.tpNumber
                          )}

                          key={ondemand.tpNumber}
                          name={ondemand.name}
                          parentCallback={this.getOrderInfo.bind(this)}
                          phoneNumber={ondemand.phoneNumber}
                          representativeFor={ondemand.representativeFor}
                          role={ondemand.role}
                          talf_id={ondemand.tpNumber}
                      />
                  ))}

                  <AddNewSigner
                      countryCode={this.props.countryCode}
                      getOnDemandSigners={this.getOnDemandSigners.bind(this)}

                  />
                  {this.props.documentDetails.some(doc => doc.code === 'ESPLOC')  && (
                      <AddNewProxy
                          allRepresentators ={this.state.onDemand.filter(ondemand => ondemand.role === 'PROXY' && ondemand.signer !== false)}
                          allThirdParties={this.state.allThirdParties}
                          countryCode={this.props.countryCode}
                          defaultTPs={this.state.defaultTPs}
                          getOnDemandSigners={this.getOnDemandSigners.bind(this)}
                      />

                  )}
              </Form>
              {this.state.signersList.length > 0 && (
                  <div className={styles.thirdPartyStepper}>
                      <br/>
                      <Divider/>
                      <p className={styles.stepperHeader}>
                          <FormattedMessage id={'labels.SIGNING_ORDER_PREVIEW'}/>
                      </p>
                      <ThirdPartyStepper
                          bgColor={'#E9F2F9'}
                          signersList={this.state.signersList}
                          status={'review'}
                      />
                  </div>
              )}
              <br/>
          </React.Fragment>
      );
  }
}
